import customerEditor from './index.js';

const SET_CORPORATE_CUSTOMER_PROPERTY = (state, {propName, propVal})=>{
  state.company[propName]=propVal;
}

const UPDATE_COMPANY_CONTACT_PROPERTY = (state, {index, propName, propVal}) => {
  state.company.contacts[index][propName]=propVal;
}

const SET_CUSTOMER_SETTINGS_PROPERTY = (state, {propName, propVal}) => {
  state.settings[propName] = propVal;
}

const  SET_INDIVIDUAL_CUSTOMER_PROPERTY = (state, {propName, propVal})=>{
  state.contact[propName]=propVal;
}

const SET_ADDRESSES = (state, addresses) => {
  state.addresses = addresses;
}

const SET_DISABLED_CTRL = (state, status) => {
  state.ctrlDisabled = status;
}

const SET_TYPE = (state, type) => {
  state.type = type;
}

const SET_PARENT = (state, parent) => {
  state.parent = parent;
}

const SET_EXTERNAL_ID = (state, externalId) => {
  state.externalId = externalId;
}

const RESET_CUSTOMER_INFO = (state) => {
  state.customerId = null;
  state.company.id = null;
  state.company.name= '';
  state.company.usual_name= '';
  state.company.email= '';
  state.company.phone= '';
  state.company.phoneExt= null;
  state.contact.id = null;
  state.contact.first_name= '';
  state.contact.last_name= '';
  state.contact.email= '';
  state.contact.phone= '';
  state.contact.phoneExt=null;
  state.contact.sex=null;
  state.contact.denomination=null;
  state.rep_id = null;
  state.territory=null;
  state.parent = null;
  state.externalId = null;
}

const ADD_ADDRESS = (state, address) =>{
  state.addresses.push(address);
}

const UPDATE_ADDRESS = (state, {index, address}) => {
  Object.assign(state.addresses[index], address);
}

const REMOVE_ADDRESS = (state, index) => {
  state.addresses.splice(index,1)
}

const ADD_COMPANY_CONTACT = (state, contact) => {
  state.company.contacts.push(contact);
}

const REMOVE_COMPANY_CONTACT = (state, index) => {
  state.company.contacts.splice(index,1);
}

const SET_COMPANY_CONTACT = (state, contacts) => {
  state.company.contacts = contacts;
}

const RESET_CONFIGURATION = (state) =>{
  Object.assign(state.settings, customerEditor.getDefaultState().settings);
}

const SET_CUSTOMER_ID = (state, customerId) => {
  state.customerId = customerId;
}

const SET_TERRITORY = (state, territory) =>{
  state.territory = territory === '' ? null : territory;
}

const SET_REP = (state, rep_id) =>{
  state.rep_id = rep_id === '' ? null : rep_id;
}

const ADD_INVOICE_REMINDER = (state, reminder) =>{
  state.settings.invoiceReminders.push(reminder);
}
const REMOVE_INVOICE_REMINDER = (state, index) =>{
  state.settings.invoiceReminders.splice(index,1);
}
const SET_INVOICE_REMINDER_CONFIGURATION_PROPERTY = (state, {propName, propVal,index}) =>{

  _.forEach(state.settings.invoiceReminders, (reminder, i)=>{
    if(i==index){
      reminder.configuration[propName]=propVal;
    }
  })
}

const SET_INVOICE_REMINDER_PROPERTY = (state, {propName, propVal,index}) =>{

  _.forEach(state.settings.invoiceReminders, (reminder, i)=>{
    if(i==index){
      reminder[propName]=propVal;
    }
  })
}

export default {
  SET_CORPORATE_CUSTOMER_PROPERTY,
  SET_INDIVIDUAL_CUSTOMER_PROPERTY,
  SET_ADDRESSES,
  SET_DISABLED_CTRL,
  SET_TYPE,
  RESET_CUSTOMER_INFO,
  ADD_ADDRESS,
  UPDATE_ADDRESS,
  REMOVE_ADDRESS,
  ADD_COMPANY_CONTACT,
  SET_COMPANY_CONTACT,
  REMOVE_COMPANY_CONTACT,
  UPDATE_COMPANY_CONTACT_PROPERTY,
  SET_CUSTOMER_SETTINGS_PROPERTY,
  RESET_CONFIGURATION,
  SET_CUSTOMER_ID,
  SET_TERRITORY,
  SET_REP,
  ADD_INVOICE_REMINDER,
  REMOVE_INVOICE_REMINDER,
  SET_INVOICE_REMINDER_CONFIGURATION_PROPERTY,
  SET_INVOICE_REMINDER_PROPERTY,
  SET_PARENT,
  SET_EXTERNAL_ID
};
